<template src="./template.html"></template>
<script>
    import { mapGetters } from 'vuex';
    import axios from 'axios';
    import InputText from '../../cmp/inputText';
    import Select from '../../cmp/select';

    export default {
        props: ['panel', 'index'],
        components: { InputText, Select },
        data () {
            return {
                selectList: [
                    { value: 'Firma', name: 'Firma' },
                    { value: 'Mr', name: 'Herr' },
                    { value: 'Mrs', name: 'Frau' },
                ],
                validPanel: false,
                limitReached: false,
                showFirma: false,
                errorsData: {
                    salutation: false,
                    company: false,
                    firstname: false,
                    lastname: false,
                    city: false,
                    street: false,
                    house_nr: false,
                    zip: false,
                    phone: false,
                    email: false,
                },
            };
        },
        computed: {
            ...mapGetters([
                'get_selected_panels', 'get_field_by_id', 'get_panel_by_id', 'get_owner', 'get_wording',
                'get_buildings', 'get_selection', 'get_supplier']),
            panelValid () {
                if (this.get_panel_by_id(this.panel.id).owner.has === false) {
                    return true;
                } else {
                    return false;
                }
            },
        },
        created () {
            if (this.get_owner(this.panel.id).email) {
                this.showOwnerInputs = true;
            }

            if (this.get_panel_by_id(this.panel.id).owner.salutation.value === 'Firma') {
                this.showFirma = true;
            }
        },
        methods: {
            emitError () {
                let thisDOM = this.$el;
                let position = window.pageYOffset + parseInt(thisDOM.getBoundingClientRect().top);
                this.$emit('emitErrorPosition', this, position);
            },
            emitPanel () {
                this.$emit('emitPanel', this, this.validPanel);
            },
            triggerPanel () {
                // Validate only if owner is checked
                if (this.get_panel_by_id(this.panel.id).owner.has) {
                    this.validateCustomer();
                } else {
                    this.validPanel = true;
                    this.emitPanel();
                }
            },
            inputChange (e, el) {
                // Run state mutation
                this.setOwnerInfo(this.panel.id, e.currentTarget.value, el.selector);
                // Reset errors
                this.errorsData[el.selector] = false;
            },
            checkAvailability () {
                // CHECK IF THIS OWNER CAN HAVE MORE PANELS
                this.$store.dispatch('SET_LOADER', false);

                const reqParams = new URLSearchParams();
                const owner = this.customerObject();

                for (let prop in owner) {
                    reqParams.append(prop, owner[prop]);
                }

                axios.get(this.$apiUrl + '/customer/find', { params: reqParams })
                    .then(() => {
                        this.validPanel = true;
                        this.emitPanel();
                    })

            },
            customerObject () {
                return {
                    salutation: this.get_owner(this.panel.id).salutation.value,
                    company: this.get_owner(this.panel.id).company,
                    firstname: this.get_owner(this.panel.id).firstname,
                    lastname: this.get_owner(this.panel.id).lastname,
                    street: this.get_owner(this.panel.id).street,
                    house_nr: this.get_owner(this.panel.id).house_nr,
                    zip: this.get_owner(this.panel.id).zip,
                    city: this.get_owner(this.panel.id).city,
                };
            },
            validateCustomer () {
                this.$store.dispatch('SET_LOADER', true);
                return axios.post(this.$apiUrl + '/customer/validateGiftOwner', this.customerObject())
                    .then(() => {
                        this.validPanel = true;
                    })
                    .catch((error) => {
                        this.emitError();
                        this.validPanel = false;

                        const resp = error.response.data;
                        const errors = error.response.data.errors;
                        if (resp.errors) {
                            // if form errors
                            this.errorsData = {};
                            for (var key in errors) {
                                this.errorsData[key] = errors[key][0];
                            }
                        } else if (resp.data.limit_error) {
                            // IF user can't have more panels
                            this.limitReachedMessage = `${resp.data.customer}: ${this.get_wording.module_nr_exceed}`;
                            this.limitReached = true;
                        }

                        this.$store.dispatch('SET_NOTIFICATION', {
                            message: this.get_wording.fix_errors,
                            type: 'warning'
                        });
                    }).finally(() => {
                        this.emitPanel();
                        this.$store.dispatch('SET_LOADER', false);
                    });
            },
            selectChange (value, name, el) {
                if (value === 'Firma') {
                    this.showFirma = true;
                } else {
                    this.showFirma = false;
                }
                this.$store.dispatch('SET_OWNER', {
                    id: this.panel.id,
                    value: {
                        value: value,
                        name: name,
                    },
                    key: 'salutation',
                });
            },
            changePanelName (e, el) {
                if (e.keyCode === 27) return;

                let panels = this.get_selected_panels;

                if (e.currentTarget.value.length === 0) {
                    panels = this.get_field_by_id(this.get_selection.activeField).panels;
                    const panelX = panels.map(p => p.id).indexOf(this.panel.id);

                    this.$store.dispatch('UPDATE_PANEL_NAME', {
                        name: panels[panelX].panel_name,
                        id: el.selector,
                        resetName: true,
                    });
                } else if (e.currentTarget.value.length < 17) {
                    this.$store.dispatch('UPDATE_PANEL_NAME', {
                        name: e.currentTarget.value,
                        id: el.selector,
                        resetName: false,
                    });
                } else {
                    let panel = this.get_panel_by_id(el.selector);
                    e.currentTarget.value = panel.panel_name;
                }
            },
            toggleOwner (id) {
                this.$store.dispatch('TOGGLE_OWNER_PANEL', id);
            },
            setOwnerInfo (id, value, key) {
                this.$store.dispatch('SET_OWNER', {
                    id: id,
                    value: value,
                    key: key,
                });
            },
            removeOwner (id) {
                this.toggleOwner();
            },
        },
    };

</script>



// WEBPACK FOOTER //
// src/components/modules/06_panel_box/index.vue